import { Progress } from "@mantine/core";
import { useEffect, useState } from "react";

type Props = {
  duration: number; // in ms
  onTimerFinish: () => void;
};

export function TimedProgressBar({ duration, onTimerFinish }: Props) {
  const [progress, setProgress] = useState(0);

  // Effect to run the timer and update the progress
  useEffect(() => {
    const updatesPerSecond = 20; // 50ms interval
    const updateInterval = 1000 / updatesPerSecond;
    const totalUpdates = duration / updateInterval;
    const increment = 100 / totalUpdates;

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + increment;
      });
    }, updateInterval);

    return () => clearInterval(interval);
  }, [duration]);

  // Effect to watch for completion and call the callback
  // this avoids the issue where the timer finishes before the progress bar is updated
  useEffect(() => {
    if (progress >= 100) {
      onTimerFinish();
    }
  }, [progress, onTimerFinish]);

  return <Progress value={progress} size="xl" radius="xl" w={300} />;
}
